// Prod
export const API_URL = "https://api.atlanticaparc.com";// "http://atlanticapark.dev.com";
export const API_MEWS = "https://api.mews.com/api/distributor/v1";
export const HOTEL_ID = "f46b1f30-f507-4ba6-8b4d-ab4c0100f936";
export const CDN_MEWS_MEDIA = "https://cdn.mews.li/Media";
export const PAYMENT_GATEWAY_PUBLIC_KEY="3000013748"
export const GOOGLE_ANALYTICS = "UA-165407372-1";
export const CLIENT = "Atlantica Parc";
export const WHATSAPP_COMPANY_NUMBER="212666855040"

// Preprod
//  export const API_URL = "https://api.preprod.atlanticaparc.com"; // "http://atlanticapark.dev.com";
//  export const API_MEWS = "https://api.mews-demo.com/api/distributor/v1";
//  export const HOTEL_ID = "b4aa38ed-1984-495b-82b3-ab4a00ed726f";
//  export const CDN_MEWS_MEDIA = "https://cdn.mews-demo.com/Media";
//  export const CLIENT = "My Client 1.0.0";
//  export const PAYMENT_GATEWAY_PUBLIC_KEY = "1100016827";
//  export const GOOGLE_ANALYTICS = "null";
//  export const WHATSAPP_COMPANY_NUMBER="212666855040"

// General
export const ADULT_COUNT_DEFAULT = 2;
// firebase
export const firebaseConfig = {
    apiKey: "AIzaSyC-OUbptGdJrKgacYj-0cj1bJQlnBQek6g",
    authDomain: "atlantica-parc-e45c3.firebaseapp.com",
    databaseURL: "https://atlantica-parc-e45c3.firebaseio.com",
    projectId: "atlantica-parc-e45c3",
    storageBucket: "atlantica-parc-e45c3.appspot.com",
    messagingSenderId: "368976404242",
    appId: "1:368976404242:web:f957206fde6de6f3fa5dcb",
    measurementId: "G-7XNCTZK903"
};
export const FIREBASE_PUBLIC_VAPID_KEY =
    "BJ9bwNE7Ygg43YD6PRDEJCD3Q-IAR1HqCao8nLvMX0_prmSHSIn8apDRbPMSeAlnW03DxTXoszKqlpOHca402kc";
